module.exports = __webpack_public_path__ + "static/media/Figure15.eb9cd5ef.jpg";